import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Dialog } from 'antd-mobile'

// 路由变化清除Dialog
const useDialogClear = () => {
  const location = useLocation()
  useEffect(() => {
    return () => {
      Dialog.clear()
    }
  }, [location])
}

export default useDialogClear
